import { activity } from '@/locales/en-US/activity';
import { assistant } from '@/locales/en-US/assistant';
import { assets } from '@/locales/en-US/assets';
import { auth } from '@/locales/en-US/auth';
import { billing } from '@/locales/en-US/billing';
import { common } from '@/locales/en-US/common';
import { compliance } from '@/locales/en-US/compliance';
import { contacts } from '@/locales/en-US/contacts';
import { copilot } from '@/locales/en-US/copilot';
import { guide } from '@/locales/en-US/guide';
import { packs } from '@/locales/en-US/packs';
import { notifications } from '@/locales/en-US/notifications';
import { home } from '@/locales/en-US/home';
import { inspections } from '@/locales/en-US/inspections';
import { jobs } from '@/locales/en-US/jobs';
import { lifecycleGate } from '@/locales/en-US/lifecycleGate';
import { navigation } from '@/locales/en-US/navigation';
import { profile } from '@/locales/en-US/profile';
import { schedule } from '@/locales/en-US/schedule';
import { sites } from '@/locales/en-US/sites';
import { timeline } from '@/locales/en-US/timeline';
import { work } from '@/locales/en-US/work';
import { workspace } from '@/locales/en-US/workspace';

export const enUSResources = {
  common,
  auth,
  navigation,
  profile,
  workspace,
  billing,
  work,
  assets,
  inspections,
  jobs,
  lifecycleGate,
  contacts,
  copilot,
  home,
  assistant,
  activity,
  schedule,
  sites,
  timeline,
  compliance,
  guide,
  packs,
  notifications,
} as const;

export type EnUSResources = typeof enUSResources;
